import { getGaIdFromCookies, getNewGaId } from './utils';

const defaultUID = getGaIdFromCookies() || getNewGaId();

const verifyUID = (uid) => {
  if (!uid || uid.search(/[^\w\-.]/) > -1) {
    return '';
  }

  return uid;
};

export const addUidInUrl = (url, uid) => {
  const regEx = /&uid=([^&]*)/;
  let uidParam = url.match(regEx);

  uid = uid || defaultUID;

  if (uidParam) {
    uidParam = uidParam[1];

    if (!uidParam || uidParam === defaultUID || verifyUID(uidParam) !== uidParam) {
      url = url.replace(regEx, `&uid=${uid}`);
    }

    return url;
  }

  url += `&uid=${uid}`;

  return url;
};
